export enum NotificationAction {
    UpsertNotification = 'reapop/upsertNotification',
    DismissNotification = 'reapop/dismissNotification',
    DismissNotifications = 'reapop/dismissNotifications',
}
